/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvZWRpdG9yL2VkaXRvci1kZW1vLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvZWRpdG9yL2VkaXRvci1kZW1vLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/editor/editor-demo.component.scss.shim.ngstyle.ts